import { Box, Tooltip } from "@mui/material";
import { SimpleTreeView } from "@mui/x-tree-view/SimpleTreeView";
import { TreeItem } from "@mui/x-tree-view/TreeItem";
import { Accordion, AccordionDetail, AccordionHeader, AccordionItem, AccordionTitle } from "@vds/accordions";
import { Icon } from "@vds/icons";
import { Body } from "@vds/typography";
import { getDeviceVirtualIdFromTagId } from "../../../../global/utility/statisticsUtil";
import { useStatisticContext } from "../../contexts/StatisticContext";
import { STATISTICS_TEST_IDS } from "../../statisticsConstants";

const LocationSelection = () => {
  const {
    accordionSiteDetails,
    setAccordionSiteDetails,
    accordionSiteOpened,
    setAccordionSiteOpened,
    activeLocationAccordion,
    setActiveLocationAccordion,
    appName,
    appNameForViewTag,
    filterlist,
    matchingLocationAreas,
    matchingLocationFloors,
    matchingLocationSubAreas,
    roisListWithApps,
    selectedAreas,
    setSelectedAreas,
    selectedFloors,
    setSelectedFloors,
    selectedSite,
    setSelectedSite,
    selectedSubAreas,
    setSelectedSubAreas,
    selectAccordionData,
    setFilterList,
    setSiteNameForViewTag,
    setSiteNameToggleDropdown,
    siteList,
    siteNameToggleDropdown,
    siteReducer,
    sites
  } = useStatisticContext();

  const toggleLocationAccordion = (index) => {
    setSiteNameToggleDropdown(activeLocationAccordion === index ? false : true);
    setActiveLocationAccordion(activeLocationAccordion === index ? null : index);
  };

  const handleFetchSelectedSiteData = (e, itemid, index) => {
    e.stopPropagation();
    setAccordionSiteOpened(index);
    setAccordionSiteDetails(itemid);
  };

  const handleItemSiteSelectionToggle = (event, itemsiteId) => {
    setSelectedFloors([]);
    setSelectedAreas([]);
    setSelectedSubAreas([]);
    if (event?.target?.checked) {
      var tempSite = siteReducer?.sites?.find((f) => f?.id === itemsiteId);
      if (tempSite) {
        tempSite["virtualId"] = getDeviceVirtualIdFromTagId(itemsiteId, roisListWithApps, appNameForViewTag);
        setSelectedSite([tempSite]);
        setAccordionSiteDetails(tempSite.id);
      }
    } else {
      setSelectedSite([]);
    }
  };

  const handleItemFloorsSelectionToggle = (floor) => {
    if (selectedFloors.find((floorData) => floorData.id === floor.id)) {
      setSelectedFloors(selectedFloors.filter((item) => item.id !== floor.id));
    } else {
      const newObject = {
        id: floor.id,
        name: floor.name,
        tagids: [floor.tagids],
        parkingcount: floor?.parkingcount === undefined ? 0 : floor?.parkingcount,
        virtualId: getDeviceVirtualIdFromTagId(floor.id, roisListWithApps, appNameForViewTag)
      };
      setSelectedFloors([...selectedFloors, newObject]);
    }
  };

  const handleItemAreasSelectionToggle = (areaid, areaname, areatagid, areaparkingCount) => {
    if (selectedAreas.find((areaData) => areaData.id === areaid)) {
      setSelectedAreas(selectedAreas.filter((item) => item.id !== areaid));
    } else {
      const newObject = {
        id: areaid,
        name: areaname,
        tagid: areatagid,
        parkingcount: areaparkingCount,
        virtualId: getDeviceVirtualIdFromTagId(areaid, roisListWithApps, appNameForViewTag)
      };
      setSelectedAreas([...selectedAreas, newObject]);
    }
  };

  const handleItemSubAreasSelectionToggle = (subareaid, subareaname, subareatagid, subareaparkingcount) => {
    if (selectedSubAreas.find((subareaData) => subareaData.id === subareaid)) {
      setSelectedSubAreas(selectedSubAreas.filter((item) => item.id !== subareaid));
    } else {
      const newObject = {
        id: subareaid,
        name: subareaname,
        tagid: subareatagid,
        parkingcount: subareaparkingcount,
        virtualId: getDeviceVirtualIdFromTagId(subareaid, roisListWithApps, appNameForViewTag)
      };
      setSelectedSubAreas([...selectedSubAreas, newObject]);
    }
  };

  /* End Location */

  // Generate siteNameForViewTag for display
  const siteNameForViewTag = selectedSite?.length > 0 ? selectedSite[0].name : siteList?.length > 0 ? siteList[0].name : "";

  const getSelectedSummaryForSite = ({
    item,
    matchingLocationFloors,
    matchingLocationAreas,
    matchingLocationSubAreas,
    selectedFloors,
    selectedAreas,
    selectedSubAreas
  }) => {
    // Get all floors for this site (item.id)
    const matchingFloors = matchingLocationFloors
      ? matchingLocationFloors.filter((floor) => Array.isArray(floor.tagids) && floor.tagids.includes(item.id))
      : [];
    // Get all areas for these floors
    const matchingAreas = matchingLocationAreas
      ? matchingLocationAreas.filter((area) => Array.isArray(area.tagids) && matchingFloors.some((floor) => area.tagids.includes(floor.id)))
      : [];
    // Get all subareas for these areas
    const matchingSubareas = matchingLocationSubAreas
      ? matchingLocationSubAreas.filter((subarea) => Array.isArray(subarea.tagids) && matchingAreas.some((area) => subarea.tagids.includes(area.id)))
      : [];

    let result = [];
    if (selectedFloors && selectedFloors.length > 0) {
      const selectedMatchingFloors = selectedFloors.filter((floor) => matchingFloors.some((mf) => mf.id === floor.id));
      if (selectedMatchingFloors.length > 0) {
        result.push(`${selectedMatchingFloors.length} floor${selectedMatchingFloors.length > 1 ? "s" : ""}`);
      }
    }
    if (selectedAreas && selectedAreas.length > 0) {
      const selectedMatchingAreas = selectedAreas.filter((area) => matchingAreas.some((ma) => ma.id === area.id));
      if (selectedMatchingAreas.length > 0) {
        result.push(`${selectedMatchingAreas.length} area${selectedMatchingAreas.length > 1 ? "s" : ""}`);
      }
    }
    if (selectedSubAreas && selectedSubAreas.length > 0) {
      const selectedMatchingSubareas = selectedSubAreas.filter((subarea) => matchingSubareas.some((msa) => msa.id === subarea.id));
      if (selectedMatchingSubareas.length > 0) {
        result.push(`${selectedMatchingSubareas.length} sub-area${selectedMatchingSubareas.length > 1 ? "s" : ""}`);
      }
    }
    return result.length > 0 ? "Selected: " + result.join("  |  ") : "";
  };

  const getSelectedSummaryForFloor = ({ floor, item, selectedAreas, selectedSubAreas }) => {
    let result2 = [];
    // Selected areas under this floor and site
    const selectedMatchingAreas = selectedAreas.filter(
      (area) =>
        Array.isArray(area.tagid) &&
        area.tagid.includes(floor.id) && // area belongs to this floor
        floor.tagids.includes(item.id) // floor belongs to this site
    );

    if (selectedMatchingAreas.length > 0) {
      result2.push(`${selectedMatchingAreas.length} area${selectedMatchingAreas.length > 1 ? "s" : ""}`);
    }

    // Selected subareas under this floor and site
    const selectedMatchingSubareas = selectedSubAreas.filter(
      (subarea) =>
        Array.isArray(subarea.tagid) &&
        // subarea.tagids[0] is the parent area id
        selectedMatchingAreas.some((area) => area.id === subarea.tagid[0])
    );
    if (selectedMatchingSubareas.length > 0) {
      result2.push(`${selectedMatchingSubareas.length} sub-area${selectedMatchingSubareas.length > 1 ? "s" : ""}`);
    }

    return result2.length > 0 ? "Selected: " + result2.join("  |  ") : "";
  };

  const getSelectedSummaryForArea = ({ area, floor, item, selectedSubAreas }) => {
    let result3 = [];
    if (selectedSubAreas && selectedSubAreas.length > 0) {
      // Only subareas whose tagids[0] is the parent area.id, and that area belongs to this floor and site
      const selectedMatchingSubareas = selectedSubAreas.filter(
        (subarea) =>
          Array.isArray(subarea.tagid) &&
          subarea.tagid[0] === area.id && // subarea belongs to this area
          Array.isArray(area.tagids) &&
          area.tagids.includes(floor.id) && // area belongs to this floor
          Array.isArray(floor.tagids) &&
          floor.tagids.includes(item.id) // floor belongs to this site
      );
      if (selectedMatchingSubareas.length > 0) {
        result3.push(`${selectedMatchingSubareas.length} sub-area${selectedMatchingSubareas.length > 1 ? "s" : ""}`);
      }
    }
    return result3.length > 0 ? "Selected: " + result3.join("  |  ") : "";
  };

  if (!(appName !== "All Apps" || sites?.length === 1)) {
    return <></>;
  }

  return (
    <>
      <div className="filterTowerItemSeparator"></div>
      <div className="filterTowerItems">
        <div className="statisticsAccordion">
          <Accordion>
            <AccordionItem opened={activeLocationAccordion === 4} style={{ fontSize: "16px", width: "90%" }}>
              <AccordionHeader
                triggerType="icon"
                style={{ top: "8px" }}
                data-testid={STATISTICS_TEST_IDS.ACCORDION_HEADER_LOCATION}
                onClick={() => {
                  toggleLocationAccordion(4);
                  setSiteNameToggleDropdown(true);
                }}
              >
                <AccordionTitle>
                  <div className="flexColumn">
                    <div className="flexRow">
                      <span style={{ paddingRight: "10px" }}>
                        <Icon name="location" />
                      </span>
                      <p
                        style={{
                          fontWeight: "100",
                          margin: "0",
                          lineHeight: "27px"
                        }}
                        size="small"
                      >
                        Location
                      </p>
                    </div>
                    {activeLocationAccordion !== 4 && (
                      <div className="filterSelectedVal">
                        Selected : <span> {siteNameForViewTag} </span>
                      </div>
                    )}
                  </div>
                </AccordionTitle>
              </AccordionHeader>
              <AccordionDetail>
                {siteNameToggleDropdown && (
                  <div
                    className="flexColumn"
                    style={{
                      marginTop: "20px",
                      marginBottom: "20px"
                    }}
                  >
                    <div className="flexColumn locationWrapper">
                      <Accordion>
                        {siteList &&
                          siteList?.map((item, index) => (
                            <AccordionItem
                              style={{
                                fontSize: "16px",
                                width: "90%",
                                marginBottom: "24px"
                              }}
                              key={index}
                              opened={accordionSiteOpened === index}
                            >
                              <AccordionHeader
                                style={{ top: "8px" }}
                                triggerType="icon"
                                openAccordionTriggerLabel="open"
                                ariaLabel={item.id}
                                onClick={(e) => handleFetchSelectedSiteData(e, item.id, index)}
                              >
                                <AccordionTitle>
                                  <div className="flexColumn treeViewContentWrapper">
                                    <Box
                                      sx={{
                                        minWidth: 290
                                      }}
                                    >
                                      <SimpleTreeView>
                                        <TreeItem
                                          style={{
                                            marginLeft: "-25px"
                                          }}
                                          itemId={item.id}
                                          label={
                                            <div className="customCheckbox">
                                              <input
                                                type="checkbox"
                                                onChange={(e) => handleItemSiteSelectionToggle(e, item.id)}
                                                checked={
                                                  selectedSite.length > 0
                                                    ? selectedSite.filter((s) => {
                                                        return s.id == item.id;
                                                      }).length > 0
                                                    : siteList[0].id == item.id
                                                }
                                                value={item.id}
                                                style={{
                                                  marginRight: "10px",
                                                  width: "20px",
                                                  height: "20px",
                                                  borderColor: "#6F7171"
                                                }}
                                              />
                                              <Tooltip
                                                placement="bottom-start"
                                                title={
                                                  <div
                                                    style={{
                                                      width: "auto",
                                                      padding: "5px",
                                                      color: "black",
                                                      fontSize: "12px",
                                                      backgroundColor: "white"
                                                    }}
                                                  >
                                                    <Body viewport="desktop" size="small" bold={true}>
                                                      {" "}
                                                    </Body>
                                                    <Body size="small" viewport="desktop">
                                                      {item.name}
                                                    </Body>
                                                  </div>
                                                }
                                                arrow
                                                slotProps={{
                                                  tooltip: {
                                                    sx: {
                                                      backgroundColor: "white",
                                                      border: "1px solid black",
                                                      "& .MuiTooltip-arrow": {
                                                        backgroundColor: "white"
                                                      }
                                                    }
                                                  }
                                                }}
                                              >
                                                <div
                                                  className="accordionText"
                                                  style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    top: "-28px",
                                                    left: "30px",
                                                    width: "100%",
                                                    gap: "0.5em",
                                                    margin: 0,
                                                    padding: 0
                                                  }}
                                                >
                                                  <span
                                                    style={{
                                                      wordBreak: "break-word",
                                                      fontSize: "1em",
                                                      lineHeight: 1.7,
                                                      overflow: "hidden",
                                                      whiteSpace: "noWrap",
                                                      textOverflow: "ellipsis",
                                                      width: "83%"
                                                    }}
                                                  >
                                                    {item.name}
                                                  </span>
                                                  <span
                                                    style={{
                                                      fontSize: "0.9em",
                                                      color: "#6F7171",
                                                      position: "relative",
                                                      top: "-15px"
                                                    }}
                                                  >
                                                    {getSelectedSummaryForSite({
                                                      item,
                                                      matchingLocationFloors,
                                                      matchingLocationAreas,
                                                      matchingLocationSubAreas,
                                                      selectedFloors,
                                                      selectedAreas,
                                                      selectedSubAreas
                                                    })}
                                                  </span>
                                                </div>
                                              </Tooltip>
                                            </div>
                                          }
                                        ></TreeItem>
                                      </SimpleTreeView>
                                    </Box>
                                  </div>
                                </AccordionTitle>
                              </AccordionHeader>
                              <AccordionDetail>
                                <div className="treeViewWrapper">
                                  <Box sx={{ minWidth: 290 }}>
                                    <SimpleTreeView>
                                      {matchingLocationFloors.map((floor) => {
                                        if (floor?.tagids?.includes(accordionSiteDetails)) {
                                          return (
                                            <TreeItem
                                              key={floor.id}
                                              itemId={floor.id}
                                              label={
                                                floor.id ? (
                                                  <div
                                                    className="treeViewContentWrapper customCheckbox siteLocationItem"
                                                    style={{
                                                      marginLeft: 30
                                                    }}
                                                  >
                                                    <input
                                                      type="checkbox"
                                                      className="checkbox"
                                                      onChange={(e) => handleItemFloorsSelectionToggle(floor)}
                                                      checked={selectAccordionData.floors.find((floorData) => floorData.id === floor.id) !== undefined}
                                                      value={floor.id}
                                                      style={{
                                                        marginRight: "10px",
                                                        width: "20px",
                                                        height: "20px",
                                                        borderColor: "#6F7171"
                                                      }}
                                                    />
                                                    <Tooltip
                                                      placement="bottom-start"
                                                      title={
                                                        <div
                                                          style={{
                                                            width: "auto",
                                                            padding: "5px",
                                                            color: "black",
                                                            fontSize: "12px",
                                                            backgroundColor: "white"
                                                          }}
                                                        >
                                                          <Body viewport="desktop" size="small" bold={true}>
                                                            {" "}
                                                          </Body>
                                                          <Body size="small" viewport="desktop">
                                                            {floor.name}
                                                          </Body>
                                                        </div>
                                                      }
                                                      arrow
                                                      slotProps={{
                                                        tooltip: {
                                                          sx: {
                                                            backgroundColor: "white",
                                                            border: "1px solid black",
                                                            "& .MuiTooltip-arrow": {
                                                              backgroundColor: "white"
                                                            }
                                                          }
                                                        }
                                                      }}
                                                    >
                                                      <div
                                                        className="accordionText"
                                                        style={{
                                                          display: "flex",
                                                          flexDirection: "column",
                                                          top: "-28px",
                                                          left: "30px",
                                                          width: "100%",
                                                          gap: "0.5em",
                                                          margin: 0,
                                                          padding: 0
                                                        }}
                                                      >
                                                        <span
                                                          style={{
                                                            wordBreak: "break-word",
                                                            fontSize: "1em",
                                                            lineHeight: 1.7,
                                                            overflow: "hidden",
                                                            whiteSpace: "noWrap",
                                                            textOverflow: "ellipsis",
                                                            width: "83%"
                                                          }}
                                                        >
                                                          {floor.name}
                                                        </span>
                                                        <span
                                                          style={{
                                                            fontSize: "0.9em",
                                                            color: "#6F7171",
                                                            position: "relative",
                                                            top: "-15px"
                                                          }}
                                                        >
                                                          {getSelectedSummaryForFloor({
                                                            floor,
                                                            item,
                                                            selectedAreas,
                                                            selectedSubAreas
                                                          })}
                                                        </span>
                                                      </div>
                                                    </Tooltip>
                                                  </div>
                                                ) : (
                                                  floor.name
                                                )
                                              }
                                            >
                                              {matchingLocationAreas.map((area) => {
                                                if (area?.tagids?.includes(floor.id)) {
                                                  return (
                                                    <TreeItem
                                                      key={area.id}
                                                      itemId={area.id}
                                                      label={
                                                        area.id ? (
                                                          <div
                                                            className="treeViewContentWrapper customCheckbox siteLocationItem"
                                                            style={{
                                                              marginLeft: 48
                                                            }}
                                                          >
                                                            <input
                                                              type="checkbox"
                                                              className="checkbox"
                                                              onChange={(e) =>
                                                                handleItemAreasSelectionToggle(
                                                                  area.id,
                                                                  area.name,
                                                                  area.tagids,
                                                                  area?.parkingcount == undefined ? 0 : area?.parkingcount
                                                                )
                                                              }
                                                              checked={selectAccordionData.areas.map((s) => s.id).indexOf(area.id) > -1}
                                                              value={area.id}
                                                              style={{
                                                                marginRight: "10px",
                                                                width: "20px",
                                                                height: "20px",
                                                                borderColor: "#6F7171"
                                                              }}
                                                            />
                                                            <Tooltip
                                                              placement="bottom-start"
                                                              title={
                                                                <div
                                                                  style={{
                                                                    width: "auto",
                                                                    padding: "5px",
                                                                    color: "black",
                                                                    fontSize: "12px",
                                                                    backgroundColor: "white"
                                                                  }}
                                                                >
                                                                  <Body viewport="desktop" size="small" bold={true}>
                                                                    {" "}
                                                                  </Body>
                                                                  <Body size="small" viewport="desktop">
                                                                    {area.name}
                                                                  </Body>
                                                                </div>
                                                              }
                                                              arrow
                                                              slotProps={{
                                                                tooltip: {
                                                                  sx: {
                                                                    backgroundColor: "white",
                                                                    border: "1px solid black",
                                                                    "& .MuiTooltip-arrow": {
                                                                      backgroundColor: "white"
                                                                    }
                                                                  }
                                                                }
                                                              }}
                                                            >
                                                              <div
                                                                className="accordionText"
                                                                style={{
                                                                  display: "flex",
                                                                  flexDirection: "column",
                                                                  top: "-28px",
                                                                  left: "30px",
                                                                  width: "100%",
                                                                  gap: "0.5em",
                                                                  margin: 0,
                                                                  padding: 0
                                                                }}
                                                              >
                                                                <span
                                                                  style={{
                                                                    wordBreak: "break-word",
                                                                    fontSize: "1em",
                                                                    lineHeight: 1.7,
                                                                    overflow: "hidden",
                                                                    whiteSpace: "noWrap",
                                                                    textOverflow: "ellipsis",
                                                                    width: "83%"
                                                                  }}
                                                                >
                                                                  {area.name}
                                                                </span>
                                                                <span
                                                                  style={{
                                                                    fontSize: "0.9em",
                                                                    color: "#6F7171",
                                                                    position: "relative",
                                                                    top: "-15px"
                                                                  }}
                                                                >
                                                                  {getSelectedSummaryForArea({
                                                                    area,
                                                                    floor,
                                                                    item,
                                                                    selectedSubAreas
                                                                  })}
                                                                </span>
                                                              </div>
                                                            </Tooltip>
                                                          </div>
                                                        ) : (
                                                          area.name
                                                        )
                                                      }
                                                    >
                                                      {matchingLocationSubAreas.map((subarea) => {
                                                        if (subarea?.tagids?.includes(area.id)) {
                                                          return (
                                                            <TreeItem
                                                              key={subarea.id}
                                                              itemId={subarea.id}
                                                              label={
                                                                subarea.id ? (
                                                                  <div
                                                                    className="treeViewContentWrapper customCheckbox siteLocationItem"
                                                                    style={{
                                                                      marginLeft: 68
                                                                    }}
                                                                  >
                                                                    <input
                                                                      type="checkbox"
                                                                      className="checkbox"
                                                                      onChange={(e) =>
                                                                        handleItemSubAreasSelectionToggle(
                                                                          subarea.id,
                                                                          subarea.name,
                                                                          subarea.tagids,
                                                                          subarea?.parkingcount === undefined ? 0 : subarea?.parkingcount
                                                                        )
                                                                      }
                                                                      checked={selectAccordionData.subareas.map((s) => s.id).indexOf(subarea.id) > -1}
                                                                      value={subarea.id}
                                                                      style={{
                                                                        marginRight: "10px",
                                                                        width: "20px",
                                                                        height: "20px",
                                                                        borderColor: "#6F7171"
                                                                      }}
                                                                    />
                                                                    <Tooltip
                                                                      placement="bottom-start"
                                                                      title={
                                                                        <div
                                                                          style={{
                                                                            width: "auto",
                                                                            padding: "5px",
                                                                            color: "black",
                                                                            fontSize: "12px",
                                                                            backgroundColor: "white"
                                                                          }}
                                                                        >
                                                                          <Body viewport="desktop" size="small" bold={true}>
                                                                            {" "}
                                                                          </Body>
                                                                          <Body size="small" viewport="desktop">
                                                                            {subarea.name}
                                                                          </Body>
                                                                        </div>
                                                                      }
                                                                      arrow
                                                                      slotProps={{
                                                                        tooltip: {
                                                                          sx: {
                                                                            backgroundColor: "white",
                                                                            border: "1px solid black",
                                                                            "& .MuiTooltip-arrow": {
                                                                              backgroundColor: "white"
                                                                            }
                                                                          }
                                                                        }
                                                                      }}
                                                                    >
                                                                      <div
                                                                        className="accordionText"
                                                                        style={{
                                                                          display: "flex",
                                                                          flexDirection: "column",
                                                                          top: "-28px",
                                                                          left: "30px",
                                                                          width: "100%",
                                                                          gap: "0.5em",
                                                                          margin: 0,
                                                                          padding: 0
                                                                        }}
                                                                      >
                                                                        <span
                                                                          style={{
                                                                            wordBreak: "break-word",
                                                                            fontSize: "1em",
                                                                            lineHeight: 1.7,
                                                                            overflow: "hidden",
                                                                            whiteSpace: "noWrap",
                                                                            textOverflow: "ellipsis",
                                                                            width: "83%"
                                                                          }}
                                                                        >
                                                                          {subarea.name}
                                                                        </span>
                                                                      </div>
                                                                    </Tooltip>
                                                                  </div>
                                                                ) : (
                                                                  subarea.name
                                                                )
                                                              }
                                                            ></TreeItem>
                                                          );
                                                        }
                                                      })}
                                                    </TreeItem>
                                                  );
                                                }
                                              })}
                                            </TreeItem>
                                          );
                                        }
                                      })}
                                    </SimpleTreeView>
                                  </Box>
                                </div>
                              </AccordionDetail>
                            </AccordionItem>
                          ))}
                      </Accordion>
                    </div>
                  </div>
                )}
              </AccordionDetail>
            </AccordionItem>
          </Accordion>
        </div>
      </div>
    </>
  );
};

export default LocationSelection;
